import { Accessor, JSX, Show } from 'solid-js';
import {
  ActionMenuItem,
  ControlDropdown,
} from '@trimble/ui-components/solidjs';

export interface ViewToolsDropdownProps {
  readonly actions: Accessor<ActionMenuItem[]>;
}

/**
 * Dropdown menu attached to the view-picker's `tune_circle` anchor. This
 * exclusively hosts panorama-mode actions like "Rotate Panoramas";
 * visibility toggles are owned by the per-pane visibility dropdown on the
 * top toolbar instead.
 */
export const ViewToolsDropdown = (
  props: ViewToolsDropdownProps
): JSX.Element => (
  <Show when={props.actions().length > 0}>
    <div class="contents" data-testid="view-tools">
      <ControlDropdown anchorIcon="tune_circle" items={props.actions()} />
    </div>
  </Show>
);
